import { CommentWithNotificationFragment } from "../types";

export const getCommentsUnviewedNotificationIds = (comments: readonly CommentWithNotificationFragment[]): readonly string[] => {
  return comments.flatMap(c => (c.notification && !c.notification.viewedAt ? c.notification.id : []));
};
